<template>
  <div class="ty-main">
    <div class="ty-breadcrumb">
      <span class="ty-breadcrumb-item">管理员设置</span>
      <span class="ty-breadcrumb-item child">添加</span>
    </div>
    <div class="ty-content white">
      <el-row>
        <el-col :span="6">
          <h4 class="tree-title">组织架构</h4>
          <el-tree
            :data="treeData"
            :props="defaultProps"
            node-key="value"
            :default-expanded-keys="[1]"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-col>
        <el-col :span="18">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item label="姓名">
              <el-input
                v-model="searchName"
                placeholder="员工"
                clearable
                @clear="reset"
                @input="onSearch"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-button plain @click="onSearch">查 询</el-button>
            </el-form-item> -->
            <!-- <el-form-item>
              <el-button plain @click="reset">重置</el-button>
            </el-form-item> -->
            <el-form-item class="fr">
              <!-- <el-button
                plain
                @click="refresh"
                :disabled="isAllowRefresh"
                :title="isAllowRefresh ? '通讯录自动更新中请稍后' : ''"
                >刷新</el-button
              > -->
              <el-button plain @click="add">添加</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            style="width: 100%"
            id="table"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="65"
              :selectable="checkSelectable"
            >
            </el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="department" label="部门">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.departmentList" :key="index"
                  >{{ item }} <i v-if="index < scope.row.departmentList.length - 1">| </i>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="toolbar">
            <div></div>
            <el-pagination
              background
              @current-change="currentChange"
              :current-page="currentPage"
              :page-size="pagesize"
              layout="total, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { departmentCycle, isAllowRefresh } from '@/utils/util'
export default {
  data() {
    this.department = []
    return {
      count: 20,
      searchName: '',
      treeData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      tableData: [],
      userSelection: [],
      defaultProps: {
        children: 'child',
        label: 'label'
      },
      isAllowRefresh: isAllowRefresh()
    }
  },
  mounted() {
    this.getDepartment()
  },
  methods: {
    getList() {
      this.$api
        .get('/api/list/department/user', {
          department_id: this.departmentId || '',
          page: this.currentPage,
          name: this.searchName
        })
        .then(res => {
          const tableData = res.data
          const department = this.department
          tableData.forEach(v => {
            // 部门转换
            v.departmentList = []
            const departmentList = v.departmentList
            const list = v.department.split('/')
            list.forEach(item => {
              if (item) {
                departmentList.push(departmentCycle(department, item))
              }
            })
          })
          this.total = res.count
          this.tableData = tableData
        })
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    getDepartment() {
      this.$api.get('/api/v1/inherit/get-department', {
        user_id: sessionStorage.getItem('user_id')
      }).then(res => {
        this.treeData = res.data
        this.department = res.data
        this.getList()
      })
    },
    arr(arr, departmentId) {
      const arr2 = []
      for (let i = 0; i < arr.length; i++) {
        if (parseInt(departmentId) === arr[i].parent_id) {
          const obj = {
            child: [],
            label: arr[i].name,
            value: arr[i].department_id
          }
          arr2.push(obj)
        }
      }
      return arr2
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    reset() {
      this.currentPage = 1
      this.searchName = ''
      this.departmentId = ''
      this.getList()
    },
    handleNodeClick(data) {
      this.departmentId = data.value
      this.currentPage = 1
      this.getList()
    },
    add() {
      if (this.userSelection.length > 0) {
        this.$api
          .get('/api/update/admin/role', {
            user_id: this.userSelection,
            type: 1
          })
          .then(res => {
            if (res) {
              this.$message.success('添加成功！')
              setTimeout(() => {
                this.$router.push('/setting/user')
              }, 3000)
            }
          })
      } else {
        this.$message.info('请选择要添加的员工！')
      }
    },
    // 判断是否可以选中
    checkSelectable(row) {
      return row.is_admin !== 1
    },
    handleSelectionChange(val) {
      const userSelection = []
      val.forEach(v => {
        userSelection.push(v.user_id)
      })
      this.userSelection = userSelection
    },
    refresh() {
      this.$api
        .get('/api/user/btn/update')
        .then(res => {
          if (res) {
            this.getList()
            this.$message.success(res)
          }
        })
        .catch(() => {
          // this.$message.error('刷新中~')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-title {
  line-height: 40px;
}
</style>
